/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/




(function() {
  // Add custom code below this line

  document.addEventListener("DOMContentLoaded", () => {
    const swatchLabel = document.querySelector(".swatch-label");
    const swatches = document.querySelectorAll(".colors-grid a");

    swatches.forEach((swatch) => {
      swatch.addEventListener("mouseenter", () => {
        const img = swatch.querySelector("img");
        if (!img) return;

        const altText = img.getAttribute("alt") || "";
        swatchLabel.textContent = altText;
      });
    });
  });


  jQuery(function ($) {

  function handleProductSlider() {

    $('.product-item__image a.product-link').each(function () {
      var $slider = $(this);

      var $bg = $slider.find('.product-item__bg');
      var $under = $slider.find('.product-item__bg__under');

      // store originals once
      if (!$slider.data('bg-stored')) {
        $slider.data('bg-stored', $bg.detach());
        $slider.data('under-stored', $under.detach());
      }

      if ($(window).width() <= 767) {

        if (!$slider.hasClass('slick-initialized')) {

          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            infinite: true,
            arrows: false,
            dots: false,
            swipeToSlide: true
          });

        }

      } else {

        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
        }

        // restore detached elements
        if ($slider.data('bg-stored')) {
          $slider.append($slider.data('bg-stored'));
          $slider.data('bg-stored', null);
        }

        if ($slider.data('under-stored')) {
          $slider.append($slider.data('under-stored'));
          $slider.data('under-stored', null);
        }
      }
    });
  }

  handleProductSlider();

  var resizeTimer;

  $(window).on('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleProductSlider, 250);
  });

});



document.addEventListener('DOMContentLoaded', function () {
  if (window.innerWidth <= 749) {
    const deferredMedia = document.querySelector('deferred-media');

    if (deferredMedia) {
      const template = deferredMedia.querySelector('template');

      if (template) {
        const content = template.content.cloneNode(true);
        deferredMedia.appendChild(content);

        deferredMedia.classList.add('deferred-media--loaded');

        const video = deferredMedia.querySelector('video');

        if (video) {
          video.play().catch(function () {});
        }
      }
    }
  }
});


document.addEventListener('DOMContentLoaded', function() {
  const observer = new MutationObserver(() => {
    const avadaButton = document.querySelector('#Avada-SC-button');
    const sizeChart = document.querySelector('.size-chart');

    if (avadaButton && sizeChart && !avadaButton.closest('.avada-button-wrapper')) {
      const wrapper = document.createElement('span');
      wrapper.classList.add('avada-button-wrapper');

      avadaButton.parentNode.insertBefore(wrapper, avadaButton);
      wrapper.appendChild(avadaButton);
      console.log("Append")

      sizeChart.appendChild(wrapper);

      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});



  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
